import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_banner = `${hostApi}/api/app/banners`;

function getBannerList(params) {
    return Vue.prototype.$http.get(api_banner, { params });
}

function getBanner(id) {
    return Vue.prototype.$http.get(`${api_banner}/${id}`);
}

export {
    getBannerList,
    getBanner,
};
